import { createAction } from '@reduxjs/toolkit';

export const trustUpdateId = createAction('trust/updateId');
export const trustUpdateUID = createAction('trust/updateUid');
export const trustUpdateSID = createAction('trust/updateSid');
export const trustUpdateIsAdded = createAction('trust/updateIsAdded');
export const trustUpdateIsActive = createAction('trust/updateIsActive');

export const trustStore = createAction('trust/store');
export const trustClear = createAction('trust/clear');

export const trustUpdateRequest = createAction('trust/updateRequest');
export const trustUpdateError = createAction('trust/updateError');
export const trustUpdateStore = createAction('trust/updateStore');

export const trustUpdateItems = createAction('trust/updateItems');
export const trustUpdateLists = createAction('trust/updateLists');

export const trustUpdateConnect = createAction('trust/updateConnect');
export const trustUpdateLayout = createAction('trust/updateLayout');
export const trustUpdateView = createAction('trust/updateView');

export const trustUpdateHeadingTitle = createAction('trust/updateHeadingTitle');
export const trustUpdateHeadingDescription = createAction('trust/updateHeadingDescription');
export const trustUpdateHeadingTextAlign = createAction('trust/updateHeadingTextAlign');
export const trustUpdateHeadingImage = createAction('trust/updateHeadingImage');
export const trustUpdateHeadingDivider = createAction('trust/updateHeadingDivider');

export const trustUpdateSectionIsBackground = createAction('trust/updateSectionIsBackground');
export const trustUpdateSectionTextColor = createAction('trust/updateSectionTextColor');
export const trustUpdateSectionBackgroundColor = createAction('trust/updateSectionBackgroundColor');
export const trustUpdateSectionOpacity = createAction('trust/updateSectionOpacity');
export const trustUpdateSectionIsFullWidth = createAction('trust/updateSectionIsFullWidth');
export const trustUpdateSectionShadow = createAction('trust/updateSectionShadow');
export const trustUpdateSectionShadowColor = createAction('trust/updateSectionShadowColor');
export const trustUpdateSectionPadding = createAction('trust/updateSectionPadding');
export const trustUpdateSectionMargin = createAction('trust/updateSectionMargin');
export const trustUpdateSectionBackgroundType = createAction('trust/updateSectionBackgroundType');
export const trustUpdateSectionBackgroundImage = createAction('trust/updateSectionBackgroundImage');
export const trustUpdateSectionGradientColor1 = createAction('trust/updateSectionGradientColor1');
export const trustUpdateSectionGradientColor2 = createAction('trust/updateSectionGradientColor2');
export const trustUpdateSectionGradientDirection = createAction('trust/updateSectionGradientDirection');
export const trustUpdateSectionGradientOffset = createAction('trust/updateSectionGradientOffset');
export const trustUpdateSectionBorder = createAction('trust/updateSectionBorder');
export const trustUpdateSectionBorderColor = createAction('trust/updateSectionBorderColor');
export const trustUpdateSectionShadowBorderColor = createAction('trust/updateSectionShadowBorderColor');
export const trustUpdateSectionShape = createAction('trust/updateSectionShape');
